import Cookie from 'js-cookie'
import { NavigationGuard } from 'vue-router'
import store from '@/store'
import userGetters from '@/store/userModule/getterTypes'
import urlHelper from '@/lib/urls'

export const isSampleScan: NavigationGuard = (to, from, next) => {
  const user = store.getters[userGetters.USER.NAMESPACED]
  if (user) next()
  if (to.params.scanId === '1') next()
  else next({ name: 'signUp', query: { redirect: urlHelper.app(to.fullPath) } })
}
